import { type SelectOption } from '@blaze-shared/shared-util';

export const AI_MODEL_OPTIONS: SelectOption<string>[] = [
  { value: 'gpt-5.5', label: 'GPT 5.5' },
  { value: 'gpt-5.5-pro', label: 'GPT 5.5 Pro' },
  { value: 'gpt-5.4', label: 'GPT 5.4' },
  { value: 'gpt-5.4-mini', label: 'GPT 5.4 Mini' },
  { value: 'gpt-5.4-nano', label: 'GPT 5.4 Nano' },
  { value: 'gpt-5.4-pro', label: 'GPT 5.4 Pro' },
  { value: 'claude-opus-4-8', label: 'Claude Opus 4.8' },
  { value: 'claude-sonnet-4-6', label: 'Claude Sonnet 4.6' },
  { value: 'claude-haiku-4-5', label: 'Claude Haiku 4.5' },
];
